import { makeStyles, TableCell } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles({
  languageCell: {
    width: "200px",
  },
  locationCell: {
    width: "300px",
  },
  dayCell: {
    width: "200px",
  },
});

const TermPaperSelectionCells = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <TableCell className={classes.languageCell}>
        -
      </TableCell>
      <TableCell className={classes.locationCell}>
        -
      </TableCell>
      <TableCell className={classes.dayCell}>
        -
      </TableCell>
    </React.Fragment>
  );
};

export default TermPaperSelectionCells;
